import Notify from "devextreme/ui/notify";

export class LogEntry {
  level: string;
  message: string;
  timestamp: string;
  constructor(level: string, args: any[]) {
    this.level = level;
    this.message = JSON.stringify(args.map(LogEntry.normalizeArg), null, 2);
    this.timestamp = new Date().toISOString();
  }

  private static normalizeArg(arg: any): any {
    if (arg instanceof Error) {
      return {
        name: arg.name,
        message: arg.message,
        stack: arg.stack,
      };
    }
    return arg;
  }
}

const MAX_LOG_ENTRIES = 400;
const TRIM_BATCH_SIZE = 100;
const theLog: LogEntry[] = [];

export function getLog() {
  return theLog;
}
function trimLog() {
  if (theLog.length >= MAX_LOG_ENTRIES + TRIM_BATCH_SIZE) {
    theLog.splice(0, TRIM_BATCH_SIZE); // Trim oldest chunk
  }
}
export function logDebugSilently(...args: any[]) {
  trimLog();
  theLog.push(new LogEntry("debug", args));
  console.log(...args);
}

export function logWarningSilently(...args: any[]) {
  trimLog();
  theLog.push(new LogEntry("warning", args));
  console.warn(...args);
}

export function logErrorSilently(...args: any[]) {
  trimLog();
  theLog.push(new LogEntry("error", args));
  console.error(...args);
}

export function logAndNotifySuccess(message: any) {
  logDebugSilently(message);
  notifySuccess(message.toString());
}

export function logAndNotifyWarning(message: any) {
  logWarningSilently(message);
  notifyWarning(message.toString());
}

export function logAndNotifyError(message: any) {
  logErrorSilently(message);
  notifyError(message.toString());
}

export function notifySuccess(message: string, duration: number = 4000) {
  Notify(message, "success", duration);
}

export function notifyWarning(message: string, duration: number = 4000) {
  Notify(message, "warning", duration);
}

export function notifyError(message: string, duration: number = 4000) {
  Notify(message, "error", duration);
}
